export const paths = {
  OVERVIEW: '',
  PROMOTIONS: 'promotions',
}

export const dashboardLinks = {
  dashboardLink: () => '',
  promotionsBaseLink: () => `/${paths.PROMOTIONS}`,
}

export type DashboardLinks = typeof dashboardLinks
